(() => {
  const key = 'nordicmax.vat-display.v1';
  let mode = 'include';
  try {
    if (localStorage.getItem(key) === 'exclude') mode = 'exclude';
  } catch (_) {}
  const update = () => {
    document.querySelectorAll('nm-vat-price,nm-vat-toggle').forEach(element => element.refresh?.());
  };
  class VatPrice extends HTMLElement {
    connectedCallback() { this.refresh(); }
    refresh() {
      const value = this.getAttribute(`data-${mode}`);
      if (value === null) return;
      const amount = this.querySelector('[data-nm-vat-amount]');
      const label = this.querySelector('[data-nm-vat-label]');
      if (amount && amount.innerHTML !== value) amount.innerHTML = value;
      if (label) label.textContent = ` ${this.getAttribute(`data-${mode}-label`) || ''}`;
      this.dataset.mode = mode;
    }
  }
  class VatToggle extends HTMLElement {
    connectedCallback() {
      this.hidden = false;
      if (!this.initialized) {
        this.initialized = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-nm-vat-mode]');
          if (!button || !this.contains(button)) return;
          mode = button.dataset.nmVatMode;
          try { localStorage.setItem(key, mode); } catch (_) {}
          update();
          this.querySelector('[data-nm-vat-status]').textContent = `${this.querySelector('.nm-vat-toggle__label').textContent}: ${button.textContent}`;
        });
      }
      this.refresh();
    }
    refresh() {
      this.querySelectorAll('[data-nm-vat-mode]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.nmVatMode === mode));
      });
    }
  }
  customElements.define('nm-vat-price', VatPrice);
  customElements.define('nm-vat-toggle', VatToggle);
  window.addEventListener('storage', event => {
    if (event.key === key) {
      mode = event.newValue === 'exclude' ? 'exclude' : 'include';
      update();
    }
  });
})();
